import * as _ from 'lodash';

import { Observable, of as observableOf } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MockService } from './mock.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { AppStore } from '../stores/app.store';
import { delay } from 'rxjs/internal/operators';

// import 'rxjs/add/observable/map';

@Injectable()
export class MessagesService {

  private data: any;
  private grouped;

  private cached;

  constructor(
    private mock: MockService,
    private httpClient: HttpClient,
    private store: AppStore) {

  }

  sessions(cached = false) {
    let dataObservable: Observable<any>;
    if (cached) {
      dataObservable = observableOf(this.cached);
    } else {
      // const url = '../../assets/sessions.json';
      // const url = 'http://direct.betterabstracts.com/demo/rest/demo?_format=json';
      // const url = 'https://eposters.betterevents.io/ecg2020/web/rest/session?_format=json';
      const url = `${environment.posters.sourceUrl}/${this.store.category}/${this.store.track}?_format=json`;
      dataObservable = this.httpClient.get<any>(url);
    }
    return dataObservable.pipe(
      map(data => {
        this.cached = data;
        let alteredData = this.store.isDebug ? data : this.removeNonPosters(data);
        alteredData = this.enrichDataWithTimes(alteredData);
        const sortedData = this.sortMessages(alteredData);
        return sortedData;
      }));
  }

  enrichDataWithTimes(sessions) {
    if (this.store.autoRotationInterval > 0) {
      return this.alterSessionTimes(sessions);
    }

    if (!this.store.isOnDemand) {
      sessions.forEach( (session, index) => {
        session.start_timestamp = new Date(session.field_mt_ses_date[0].value).getTime();
        session.end_timestamp = session.start_timestamp + session.field_mt_ses_duration[0].value * 60000;
      });
    }
    return sessions;
  }

  removeNonPosters(sessions) {
    return sessions.filter(session => {
      return session.field_mt_ses_files && session.field_mt_ses_files.length > 0;
    });
  }

  sortMessages(messages) {
    if (this.store.isOnDemand) {
      // Sort messages by their abstract ID
      return messages.sort((a, b) => {
        return a.field_mt_ses_abstract_id[0].value.localeCompare(b.field_mt_ses_abstract_id[0].value);
      });
    }

    // Sort messages by their start time
    return messages.sort((a, b) => a.start_timestamp - b.start_timestamp);
  }

  // Enable 1 minute rotation. Present the first frame now and the next
  // when time reaches the nearest minute
  alterSessionTimes(sessions) {
    sessions.forEach( (session, index) => {
      if (index === 0) {
        // Round minutes down
        // session.start_timestamp = Math.floor(new Date().getTime() / 60000) * 60000;
        session.start_timestamp = new Date().getTime();
      } else {
        session.start_timestamp = sessions[index - 1].end_timestamp;
      }
      session.end_timestamp = session.start_timestamp + this.store.autoRotationInterval;
    });

    return sessions;
  }
}
